import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/Global.css'
import '@/assets/js/app'
createApp(App).use(store).use(router).mount('#app')
